import * as React from "react";
import { SVGProps } from "react";
const SvgCareerManagement = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={24} height={24} rx={4} fill="#095921" />
    <path
      d="M12.9 18c-1.08 0-2-.38-2.76-1.14C9.38 16.1 9 15.18 9 14.1v-.345a3.48 3.48 0 0 1-2.145-1.208C6.285 11.882 6 11.1 6 10.2V6.6h1.8V6H9v2.4H7.8v-.6h-.6v2.4c0 .66.235 1.225.705 1.695S8.94 12.6 9.6 12.6c.66 0 1.225-.235 1.695-.705S12 10.86 12 10.2V7.8h-.6v.6h-1.2V6h1.2v.6h1.8v3.6c0 .9-.285 1.682-.855 2.347a3.48 3.48 0 0 1-2.145 1.208v.345c0 .75.262 1.388.787 1.913a2.605 2.605 0 0 0 1.913.787c.75 0 1.388-.262 1.913-.787A2.605 2.605 0 0 0 15.6 14.1v-1.005a1.747 1.747 0 0 1-.863-.645 1.745 1.745 0 0 1-.337-1.05c0-.5.175-.925.525-1.275.35-.35.775-.525 1.275-.525.5 0 .925.175 1.275.525.35.35.525.775.525 1.275 0 .39-.112.74-.337 1.05-.225.31-.513.525-.863.645V14.1c0 1.08-.38 2-1.14 2.76-.76.76-1.68 1.14-2.76 1.14Zm3.3-6c.17 0 .312-.058.427-.173a.579.579 0 0 0 .173-.427.581.581 0 0 0-.173-.428.58.58 0 0 0-.427-.172.58.58 0 0 0-.427.172.581.581 0 0 0-.173.428c0 .17.058.312.173.427A.579.579 0 0 0 16.2 12Z"
      fill="#fff"
    />
  </svg>
);
export default SvgCareerManagement;
